export default "__VITE_ASSET__c9d3b96d__"